import {useAddTag as useAddInfusionsoftTag} from 'Event/infusionsoft'
import {useAddTag as useAddMailchimpTag} from 'Event/mailchimp'
import {useAddTag as useAddZapierTag} from 'Event/zapier'
import {useAddTag as useAddHubspotTag} from 'Event/hubspot'
import {useAddTag as useAddHubspotV2Tag} from 'Event/hubspot-v2'
import {useAddTag as useActiveCampaignTag} from 'Event/activeCampaign'
import {useAddTag as useAddHighLevelTag} from 'Event/highlevel'
import {useAddTag as useAddConvertKitTag} from 'organization/Event/Services/Apps/ConvertKit/Config/Tags'
import {useAddTag as useAddOntraportTag} from 'organization/Event/Services/Apps/Ontraport/Config/Tags'
import {useAddTag as useAddClickFunnelsTag} from 'organization/Event/Services/Apps/ClickFunnels/Config/Tags'
import {HasServiceTags} from 'organization/Event/Services/service-tags'

export function useApplyServiceTags(tags: HasServiceTags) {
  const addInfusionsoftTag = useAddInfusionsoftTag()
  const addMailchimpTag = useAddMailchimpTag()
  const addZapierTag = useAddZapierTag()
  const addHubspotTag = useAddHubspotTag()
  const addHubspotV2Tag = useAddHubspotV2Tag()
  const addActiveCampaignTag = useActiveCampaignTag()
  const addHighLevelTag = useAddHighLevelTag()
  const addConvertKitTag = useAddConvertKitTag()
  const addOntraportTag = useAddOntraportTag()
  const addClickFunnelsTag = useAddClickFunnelsTag()

  return () => {
    if (tags.infusionsoftTag) {
      addInfusionsoftTag(tags.infusionsoftTag)
    }

    if (tags.mailchimpTag) {
      addMailchimpTag(tags.mailchimpTag)
    }

    if (tags.zapierTag) {
      addZapierTag(tags.zapierTag)
    }

    if (tags.hubspotTag) {
      addHubspotTag(tags.hubspotTag)
    }

    if (tags.hubspotV2Tag) {
      addHubspotV2Tag(tags.hubspotV2Tag)
    }

    if (tags.activeCampaignTag) {
      addActiveCampaignTag(tags.activeCampaignTag)
    }

    if (tags.highLevelTag) {
      addHighLevelTag(tags.highLevelTag)
    }

    if (tags.convertKitTag) {
      addConvertKitTag(tags.convertKitTag)
    }

    if (tags.ontraportTag) {
      addOntraportTag(tags.ontraportTag)
    }

    if (tags.clickFunnelsTag) {
      addClickFunnelsTag(tags.clickFunnelsTag)
    }
  }
}
